import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EmailDialog, OnboardingDialog } from 'src/app/@Dialogs';

@Component({
  selector: 'admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss'],
  standalone: false,
})
export class AdminComponent {
  constructor(private matDialog: MatDialog) {}

  protected search: string;

  public openOnboarding(): void {
    this.matDialog.open(OnboardingDialog, {
      panelClass: 'dialog-wrapper',
      width: '90vw',
      height: '90vh',
      maxHeight: '90vh',
      maxWidth: '90vw',
    });
  }

  public openEmail(): void {
    this.matDialog.open(EmailDialog, {
      panelClass: 'dialog-wrapper',
      width: '50vw',
      height: '75vh',
      maxHeight: '75vh',
      maxWidth: '50vw',
    });
  }

  protected updateSearch(search: string): void {
    this.search = search;
  }
}
